import React from 'react'
import Ankle from './Ankle'
import BreadCrumbs from './BreadCrumbs'
import './DetailTemplate.scss'
import Footer from './Footer'
import SectionHeader from './SectionHeader'

const DetailTemplate = ({detailTitle, topicTitle, sectionTitle, path, image, shortHeader=false, children}) => {
  const style = {
    backgroundImage: `linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.1) 66%, rgba(0,0,0,0.9) 100%), url(${image})`,
  };

  const headerClass = shortHeader ? "header short" : "header";
  return (
    <div className='DetailTemplate'>
      <SectionHeader >
      </SectionHeader>
      <div className='desktop-width-guard'>
        <BreadCrumbs detailTitle={detailTitle} topicTitle={topicTitle} sectionTitle={sectionTitle} path={path} />
        <div className={headerClass} style={style}>
          <div className="headers">
            <h1>{detailTitle}</h1>
          </div>
        </div>
        <div className='desktop-styling'>
          <div className="crib">
            {children}
          </div>
          <Ankle>
          </Ankle>
        </div>
      </div>
      <Footer>
      </Footer>
    </div>
  )
}

export default DetailTemplate